var React = require('react');

function IcDownload (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 9.5h4l-7 7-7-7h4v-6h6v6Zm4 11v-2H5v2h14Z","fill":"currentColor"}));
}

IcDownload.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = IcDownload;

IcDownload.default = IcDownload;
